import type { PartnerProductPriceSuggestion } from "@stockline/shared/types/ai/partner-product-price-suggestion"
import type { OfflineResourceConfig } from "../../../types"
import { PARTNER_PRODUCT_PRICE_SUGGESTION_TABLE } from "./db"

export const partnerProductPriceSuggestionConfig: OfflineResourceConfig<PartnerProductPriceSuggestion> =
  {
    name: "partner-product-price-suggestions",
    endpoints: {
      full: "/api/v2/partner-product-price-suggestions",
      delta: "/api/v2/partner-product-price-suggestions/changes",
      push: "/api/v2/partner-product-price-suggestions/changes",
    },
    tableName: PARTNER_PRODUCT_PRICE_SUGGESTION_TABLE,
    primaryKey: "id",
    indexes: {
      companyId: "companyId",
      targetId: "targetId",
    },
    applyChange: (local, patch) => ({ ...local, ...patch }),
    // Tombstones stay in Dexie (pulls deliver them as upserts carrying
    // `deletedAt`); readers filter `deletedAt` themselves.
    softDelete: true,
  }
